import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import getAddressObject from '../../utils/googleAddress';
import {
  provinceAdminiterativeLevel,
  storageItemProvince
} from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import Note from '../../note';

const FieldLocationInput = ({ data }) => {
  const [query, setQuery] = useState(null);
  const autoCompleteRef = useRef(null);
  const {
    name,
    value,
    maxLength,
    minLength,
    onChange,
    readonly,
    type,
    sysId,
    disabled,
    isSameAs,
    isShowNoteBackground,
    note,
    removeLocalStorageOnChange = false
  } = data;
  let autoComplete;
  const handlePlaceSelect = updateQuery => {
    const addressObject = autoComplete.getPlace();
    const { address_components } = addressObject || {};
    let province = null;
    let locality = null;
    if (address_components) {
      addressObject.address_components.forEach(component => {
        if (component.types.includes(provinceAdminiterativeLevel)) {
          province = component.short_name;
        }
        if (component.types.includes("locality")) {
          locality = component.short_name;
        }
      });
    }
    if (province) {
      window.localStorage.setItem(storageItemProvince, province);
    }
    if (locality) {
      window.localStorage.setItem('locality', locality);
    } else {
      window.localStorage.removeItem('locality');
    }
    const queryRes =
      type === 'Address'
        ? addressObject.formatted_address
        : getAddressObject(addressObject.address_components);
    updateQuery(queryRes);
  };

  function handleScriptLoad(updateQuery) {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      { types: ['geocode'], componentRestrictions: { country: 'ca' } }
    );
    autoComplete.setFields(['address_components', 'formatted_address']);
    autoComplete.addListener('place_changed', () =>
      handlePlaceSelect(updateQuery)
    );
  }

  useEffect(() => {
    handleScriptLoad(setQuery);
  }, []);

  useEffect(() => {
    if (query !== null) {
      const e = { target: { value: query, name } };
      onChange(e);
    }
  }, [query]);

  let currentValue =
    type === 'Address' ? query : (query && query.streetNumber) || '';
  if (isSameAs) {
    currentValue = value;
  }
  const fieldKey = `location${sysId}${name}`;

  const localizedStrings = useLocalizedStringsContext();
  const {
    fieldLocation: { placeholder }
  } = localizedStrings;

  return (
    <React.Fragment>
      {note && note.content && (
        <Note
          type="richText"
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
      <input
        ref={autoCompleteRef}
        onChange={e => {
          removeLocalStorageOnChange &&
            window.localStorage.removeItem('province');
          setQuery(e.target.value);
        }}
        id={fieldKey}
        name={fieldKey}
        value={currentValue || value || ''}
        maxLength={maxLength}
        minLength={minLength}
        disabled={disabled}
        readOnly={readonly}
        className="frg-input-field color-light"
        style={{ width: '100%' }}
        placeholder={placeholder}
        onKeyPress={e => {
          e.key === 'Enter' && e.preventDefault();
        }}
      />
    </React.Fragment>
  );
};

FieldLocationInput.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sysId: PropTypes.string.isRequired,
    type: PropTypes.string,
    value: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    isSameAs: PropTypes.bool
  }).isRequired
};

export default FieldLocationInput;
